import React, { useState, useEffect } from 'react'
import useAxios from 'axios-hooks'
import styled from '@emotion/styled'
import { PageCrumbs } from 'components'
import { Button, Modal, Form, Input } from 'antd'
import { notificationToast } from 'components'
import { getAuthHeader } from 'utils/auth'
import FormFooter from 'views/ScanSettings/components/ScanFilterBar/FormFooter'

const { Search } = Input

const FIELDS_NAMES = {
  NAME: 'admin_first_name',
  SURNAME: 'admin_last_name',
  EMAIL: 'admin_email',
  PASSWORD: 'admin_password',
  COMPANY_NAME: 'account_name',
  PHONE: 'phone'
}

const firstStepData = [
  {
    name: FIELDS_NAMES.NAME,
    ruleMsg: 'Name is Required',
    children: () => <Input placeholder="NAME" />
  },
  {
    name: FIELDS_NAMES.SURNAME,
    ruleMsg: 'Surname is Required',
    children: () => <Input placeholder="SURNAME" />
  },
  {
    name: FIELDS_NAMES.EMAIL,
    ruleMsg: 'Email is Required',
    children: () => <Input type="email" placeholder="EMAIL" />
  },
  {
    name: FIELDS_NAMES.PASSWORD,
    ruleMsg: 'Password is Required',
    children: () => <Input type="password" placeholder="PASSWORD" />
  },
  {
    name: FIELDS_NAMES.COMPANY_NAME,
    ruleMsg: 'Company name is Required',
    children: () => <Input placeholder="COMPANY NAME" />
  },
  {
    name: FIELDS_NAMES.PHONE,
    children: () => <Input type="phone" placeholder="PHONE" />
  }
]

const StyledAccountsListTop = styled.div({
  display: 'grid',
  gridTemplateColumns: '1fr 152px',
  marginBottom: 20
})

const StyledPageCrumbs = styled(PageCrumbs)((props) => ({
  marginBottom: 10
}))

const AccountsListTop = ({ form, listAccount, onSearch }) => {
  const { getFieldDecorator } = form
  const [createAccountModalvisible, setCreateAccountModalvisible] = useState(false)

  const [
    { data: createAccountData, loading: createAccountLoading, error: createAccountError },
    createAccount
  ] = useAxios(
    {
      url: `/administration/accounts`,
      method: 'POST',
      headers: getAuthHeader(),
      validateStatus: false
    },
    { manual: true }
  )

  const addAccount = (event) => {
    event.preventDefault()
    form.validateFields().then((values) => {
      const { admin_first_name, admin_last_name, admin_email, admin_password, account_name, phone } = values
      createAccount({
        data: { admin_first_name, admin_last_name, admin_email, admin_password, account_name, phone }
      })
    })
  }

  useEffect(() => {
    if (createAccountData) {
      if (createAccountData.Errors) {
        notificationToast({
          message: 'Error',
          description: `Error while adding an account. ${createAccountData.Errors.join('\n\n')}`,
          icontype: 'alert'
        })
      } else {
        setCreateAccountModalvisible(false)
        notificationToast({
          message: 'Success',
          description: 'Account has been added. Now you can add domains & credits.',
          icontype: 'check'
        })
        listAccount()
      }
    }
  }, [createAccountData])

  const onReset = () => {
    form.resetFields()
  }

  return (
    <>
      <StyledPageCrumbs crumbs={[{ name: 'Administration', icon: 'bars' }]} style={{ 'margin-bottom': '10px' }} />
      <StyledAccountsListTop>
        <Search
          placeholder="search account by name or type"
          onChange={(event) => onSearch(event.target.value)}
          style={{ width: 350 }}
        />
        <Button type="primary" icon="plus" onClick={() => setCreateAccountModalvisible(!createAccountModalvisible)}>
          ADD ACCOUNT
        </Button>
      </StyledAccountsListTop>

      <Modal
        title="Add Account"
        width={450}
        visible={createAccountModalvisible}
        closable={false}
        maskClosable={false}
        destroyOnClose={true}
        afterClose={onReset}
        footer={<FormFooter onOK={addAccount} onClose={() => setCreateAccountModalvisible(false)} okText="ADD" />}
      >
        <Form layout="vertical" hideRequiredMark onSubmit={() => addAccount(form)}>
          {firstStepData.map((item) => (
            <Form.Item>
              {getFieldDecorator(item.name, {
                validateTrigger: ['onChange', 'onBlur'],
                rules: [
                  {
                    required: !!item.ruleMsg,
                    whitespace: true,
                    message: item.ruleMsg
                  }
                ]
              })(item.children())}
            </Form.Item>
          ))}
        </Form>
      </Modal>
    </>
  )
}

export default Form.create({})(AccountsListTop)
